import { ColumnSortType, TableColumnTypes } from '../../model/table.model';


export const tableHeaders = [
  {
    value: 'primary',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.CHECKBOX,
    className: 'table-checkbox'
  },
  {
    value: 'ttn',
    sort: ColumnSortType.NONE,
    name: 'ttn',
    type: TableColumnTypes.TEXT_COPY,
    className: 'table-header',
    translate: true
  },
  {
    value: 'status',
    sort: ColumnSortType.NONE,
    name: 'status',
    type: TableColumnTypes.NOVA_POSHTA_STATUS,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'np_status',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
  },
  {
    value: 'phone',
    sort: ColumnSortType.NONE,
    name: 'phone',
    type: TableColumnTypes.PHONE,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'comments',
    sort: ColumnSortType.NONE,
    name: 'comment',
    type: TableColumnTypes.TEXT,
    className: 'table-header',
    translate: true,
  },
  {
    value: 'np_sending_date',
    sort: ColumnSortType.NONE,
    name: 'sent_at',
    type: TableColumnTypes.DATE,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'np_delivery_date',
    sort: ColumnSortType.NONE,
    name: 'delivered_at',
    type: TableColumnTypes.DATE,
    className: 'table-header',
    disabled: true,
    translate: true,
  },
  {
    value: 'np_scheduled_delivery_date',
    sort: ColumnSortType.NONE,
    name: 'approximate_arrival_date',
    type: TableColumnTypes.DATE,
    className: 'table-header',
    disabled: true,
    translate: true
  },
  // {
  //   value: 'created_at',
  //   sort: ColumnSortType.NONE,
  //   name: 'Створено',
  //   type: TableColumnTypes.DATE,
  //   className: 'table-header',
  // },
  // {
  //   value: 'updated_at',
  //   sort: ColumnSortType.NONE,
  //   name: 'Обновлено',
  //   type: TableColumnTypes.DATE,
  //   className: 'table-header',
  // },
  {
    value: 'action',
    sort: ColumnSortType.NONE,
    name: '',
    type: TableColumnTypes.ACTION,
    className: 'three-dot',
    actions:
      [
        {icon: 'edit', label: 'edit', value: 'EDIT'},
        {icon: 'delete', label: 'delete', value: 'DELETE'},
      ],
    translate: true
  },
];

export enum NP_HOTKEYS {
  ADD_TTN = 'Alt+N (Windows) / Option+N (Mac)',
  FOCUS_SEARCH = 'Alt+F (Windows) / Option+F (Mac)',
  CLEAR_SELECTION = 'Escape',
  NEXT_FIELD = 'Enter',
  SUBMIT_MODAL = 'Ctrl+Enter / Control+Enter',
}
